import React from 'react';

function LoadingView() {
  return (
    <div style={{ width: '100%', height: '1005' }} className="LoadingView" />
  );
}

export default LoadingView;
